import Vue from 'vue';
import { range, differenceWith, isEqual } from 'lodash';
import { BfButton } from 'components/Butterfly';
import ToggleCheckbox from 'components/widgets/ToggleCheckbox.vue';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    components: { BfButton, ToggleCheckbox },
    props: {
        quickOptions: { type: Array, required: false, default: () => [] },
        defaultSelection: { type: String, default: 'TOP 20' },
        items: { type: Array, required: false, default: () => [] }
    },
    data() {
        return {
            selectedOption: this.defaultSelection,
            selectedItems: range(this.labelToNItems(this.defaultSelection)),
        };
    },
    watch: {
        selectedItems(value) {
            this.$emit('selected', value);
        },
        items(value, oldValue) {
            const diff = differenceWith(value, oldValue, isEqual);
            if (diff.length > 0) {
                this.selectedOption = this.defaultSelection;
                this.selectedItems = range(this.labelToNItems(this.defaultSelection));
            }
        }
    },
    methods: {
        noValue: FormatUtils.noValue,
        labelToNItems(label) {
            switch (label) {
                case 'ALL':
                    return this.items.length;
                case 'None':
                    return 0;
                default:
                    const num = parseInt(label.replace(/^TOP/, ''));
                    if (!isNaN(num)) {
                        return Math.min(num, this.items.length);
                    }
                    return 0;
            }
        },
        setOption(value) {
            this.selectedOption = value;
            this.selectedItems = range(this.labelToNItems(value));
        },
        toggleSelection(index, checked) {
            if (checked) {
                this.selectedItems = this.selectedItems.concat(index).sort((a, b) => {
                    if (a < b)
                        return -1;
                    if (a > b)
                        return 1;
                    return 0;
                });
            }
            else {
                this.selectedItems = this.selectedItems.filter(i => i !== index);
            }
        }
    }
});
